import { eventStatuses } from "../Constants";

/** Events list tab of the events saved with no payment submitted (PROLINE-3923). */
export const COMPANY_EVENT_DRAFT_TAB = eventStatuses.draft;

/** Events list tab of the events whose publishing request waits on the Super Admin. */
export const COMPANY_EVENT_PENDING_TAB = "pending";

/**
 * Tab an event is listed under. `pending_payment` events sit under the Pending tab;
 * every other status is its own tab.
 */
export const getCompanyEventListTab = (event) =>
  event?.status === eventStatuses.pendingPayment
    ? COMPANY_EVENT_PENDING_TAB
    : event?.status;

/** `status` the API is asked for on a list tab. */
export const getCompanyEventListStatusParam = (tab) =>
  tab === COMPANY_EVENT_PENDING_TAB ? eventStatuses.pendingPayment : tab;
